<!--
 * @Descripttion:
 * @Author:
 * @Date: 2020-03-09 09:12:07
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-03-09 10:28:17
 -->
<template>
  <div id="app">
    <!-- <router-view v-if="isReload" /> -->
    <keep-alive >
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive&&isReload"></router-view>

    <Loading v-if="$store.state.showLoading"></Loading>
    <FormulaDlg
      :visible.sync="$store.state.formulaDlg.show"
      @on-formula-img="onFormulaImg"
    ></FormulaDlg>
    <CouponDlg :visible.sync="$store.state.couponDlg.show"></CouponDlg>
  </div>
</template>
<script>
import Loading from "@/components/Loading.vue";
import FormulaDlg from "@/components/FormulaDlg";
import CouponDlg from "@/components/CouponDlg";
export default {
  name: "App",
  components: { Loading, FormulaDlg, CouponDlg },
  data() {
    return {
      isReload: true,
    };
  },
  computed: {
    formulaDlg() {
      return this.$store.state.formulaDlg;
    },
  },
  created() {
    this.$eventBus.$on("reload", this.onReload);
  },
  mounted() {
    // this.$kefu()

        this.$router.beforeEach((to, from, next) => {
          // console.log(to.name)

          // if(from.name=='NewsShow' || to.name=='News'){
          //   to.meta.keepAlive = true // 启用缓存
          // }else{
          //   to.meta.keepAlive = false // 禁用缓存
          // }
        // 如果是从详情页返回列表页
        if (from.name=='NewsShow' && to.name === 'News') {
          to.meta.keepAlive = true // 启用缓存
        }
        // 如果是从其他页面进入列表页
        else if (to.name === 'News') {
          to.meta.keepAlive = false // 禁用缓存
        }
        next()
      })
  },
  methods: {
    onReload() {
      this.isReload = false;
      this.$nextTick(() => {
        this.isReload = true;
      });
    },
    onFormulaImg(base64) {
      this.$eventBus.$emit(
        "getFormulaImg",
        this.formulaDlg.uid,
        this.formulaDlg.selectionIndex,
        base64,
      );
    },
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "description",
          content: this.$store.state.webConfig.web_description,
        },
        { name: "keywords", content: this.$store.state.webConfig.web_keywords },
      ],
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/css/common.scss";
#app {
  height: 100%;
}
</style>
